// src/config/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import HomePage from '../pages/HomePage';
import AboutPage from '../pages/AboutPage';
import SettingsPage from '../pages/SettingsPage';
import LoginPage from '../features/auth/LoginPage';
import SignUpPage from '../features/auth/SignUpPage';
import ToolCategoryPage from '../pages/ToolCategoryPage';
import ToolPage from '../pages/ToolPage';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import TermsPage from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';
import ContactPage from '../pages/ContactPage';
// --- Import new auth pages ---
import AuthCallbackPage from '../pages/AuthCallbackPage';
import RequestPasswordResetPage from '../pages/RequestPasswordResetPage';
import ConfirmPasswordResetPage from '../pages/ConfirmPasswordResetPage';


export const routes: RouteObject[] = [
    {
        path: '/',
        element: <MainLayout />,
        children: [
            { index: true, element: <HomePage /> },
            { path: 'about', element: <AboutPage /> },
            { path: 'terms', element: <TermsPage /> },
            { path: 'privacy', element: <PrivacyPage /> },
            { path: 'contact', element: <ContactPage /> },
            {
                element: <ProtectedRoute />,
                children: [
                    { path: 'settings', element: <SettingsPage /> },
                ],
            },
            { path: 'tools/:category', element: <ToolCategoryPage /> },
            { path: 'tools/:category/:tool', element: <ToolPage /> },
        ],
    },
    // --- Auth routes are outside the MainLayout ---
    {
        path: '/login',
        element: <LoginPage />,
    },
    {
        path: '/signup',
        element: <SignUpPage />,
    },
    {
        path: '/auth/callback', // Route for Google OAuth popup
        element: <AuthCallbackPage />
    },
    {
        path: '/forgot-password',
        element: <RequestPasswordResetPage />
    },
    {
        path: '/reset-password/:token', // Route for confirming the password reset
        element: <ConfirmPasswordResetPage />
    },
    // { path: '*', element: <NotFoundPage /> },
];